const Facebook = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2C8.26801 2 2 8.30631 2 16.0856C2 23.1161 7.3071 28.9433 14 30V20H10V16H14V13C14 9.46981 15.8021 7 19 7C20.5317 7 22.5 7.5 22.5 7.5L22 11H20.5C18.7609 11 18 12.3861 18 13.5V16H22L21 20H18V30C24.6929 28.9433 30 23.1161 30 16.0856C30 8.30631 23.732 2 16 2Z"
      fill="#1877F2"
    />
  </svg>
);

export default Facebook;
